import { useSelector } from 'react-redux';
import { ReactComponent as Download } from '../../images/icons/download.svg';
import { findMostRecentByCreatedAt } from '../../utils/helpers';

function PrescriptionDownloadLink({ label, styling, type }) {
    const { storageToken } = useSelector((state) => state.auth);
    const { user } = useSelector((state) => state.auth);

    //Find the most recent prescription of that type
    const mostRecentPrescriptionOfType = findMostRecentByCreatedAt(
        user?.patientProfile?.prescriptions?.filter((prescription) => prescription.type === type),
    );

    //Find the most recent file on that prescription
    const mostRecentFile = findMostRecentByCreatedAt(mostRecentPrescriptionOfType?.files);

    //If the user has no file of this prescription type or no storage token to fetch a file, return null
    if (!mostRecentFile || !storageToken) {
        return null;
    }

    return (
        <a
            href={`${process.env.REACT_APP_API_BASE_URL}/files/${mostRecentFile.id}?storageToken=${storageToken}`}
            target="_blank"
            rel="noreferrer"
            className={`${styling} flex items-center`}>
            <span>{label}</span>
            <Download className="absolute right-3 top-1/2 -translate-y-1/2 lg:right-5" />
        </a>
    );
}

export default PrescriptionDownloadLink;
